import { Plate } from 'features/shared/ui/Page';
import styled, { css } from 'styled-components';

export const Header24h34 = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  color: rgba(9, 21, 38, 0.85);
`;

const Text16h22o60 = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;
const Text16h22o85 = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
`;

export const NumberText = styled(Text16h22o60)`
  width: 288px;
`;

export const InnerText = Text16h22o85;

export const Statistics = styled.div`
  display: flex;
`;

export const StatisticsItem = styled.div``;

export const PlateStyled = styled(Plate)`
  padding: 24px;
  box-shadow: 0px 4px 8px 0px #394e7f33;
`;
